import styled from "styled-components";

export const OrderPageContainer = styled.div``;
